import React, { useEffect, useState } from "react";
import allenLogo from "../../../images/allenLogo.png";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import user from "../../../images/user.png";
import { decryptData } from "../../../crypto";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useLanguages } from "../../../context/LanguagesContext";

function Header() {
  const [hover, setHover] = useState(false);
  const [openInstructions, setOpenInstructions] = useState(false);
  const [examInstructions, setExamInstructions] = useState(
    sessionStorage.getItem("examInstructions")
  );
const clientLogo = sessionStorage.getItem('client_logo')

  const examName = decryptData(sessionStorage.getItem("exam_name"));

  const { selectedLanguage } = useLanguages();

  const handleOpenInstructions = () => {
    setOpenInstructions(true);
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
  };

  useEffect(() => {
    if (selectedLanguage && selectedLanguage !== "english") {
      setExamInstructions(sessionStorage.getItem("instructionsHindi"));
    }
  }, [selectedLanguage]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        borderBottom: "1px solid black",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
        <img src={clientLogo} alt="logo" width={100} height={40} />
        <Typography fontWeight={"bold"}>{examName}</Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "35px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <InfoOutlinedIcon style={{ fontSize: 20 }} />
          <Typography
            style={{
              cursor: "pointer",
              textDecoration: hover ? "underline" : "none",
              transition: "all 0.2s ease",
              fontSize: "14px",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={handleOpenInstructions}
          >
            Instruction
          </Typography>{" "}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img src={user} alt="logo" height={30} />
          {/* <Typography fontWeight={"bold"}>ibt allen</Typography> */}
          <Typography fontWeight={"bold"}>ibt exam</Typography>
        </div>
      </div>

      <Dialog
        open={openInstructions}
        onClose={handleCloseInstructions}
        maxWidth={false}
        PaperProps={{
          style: {
            width: "80vw",
            height: "80vh",
            // maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1374aa",
            p: 0, // removes default padding
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              color: "white",
            }}
          >
            <span>Exam Instructions</span>
            <IconButton onClick={handleCloseInstructions} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            style={{
              whiteSpace: "pre-line",
              "& img": {
                width: "100% !important",
                height: "auto !important",
                maxWidth: "100%", // Ensures responsiveness
              },
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: decryptData(examInstructions),
              }}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Header;
